export enum SOCIAL_PUBLISHERS {
    FACEBOOK = 'facebook.com',
    TWITTER = 'x.com',
    INSTAGRAM = 'instagram.com',
    TIKTOK = 'tiktok.com',
    PINTEREST = 'pinterest.com',
    LINKEDIN = 'linkedin.com',
}
